import { useEffect, useState } from "react";
import { CardA } from "../../ui/Cards";
import ErrorReference from "../../ui/ErrorReference";

const WizardCalibrateFail = ({ step, changeStep, pageID }) => {
  const [message, setMessage] = useState("");
  const [stage, setStage] = useState("");
  const [requestId, setRequestId] = useState(null);
  const [showTroubleshoot, setShowTroubleshoot] = useState(false);

  useEffect(() => {
    if (step === pageID) {
      const storedMsg =
        sessionStorage.getItem("calibrationErrorMessage") ||
        "Calibration failed.";
      const storedStage =
        sessionStorage.getItem("calibrationErrorStage") || "unknown";
      setMessage(storedMsg);
      setStage(storedStage);
      setRequestId(sessionStorage.getItem("calibrationErrorReference"));
    }
  }, [step, pageID]);

  if (step !== pageID) return null;

  const clearError = () => {
    sessionStorage.removeItem("calibrationErrorMessage");
    sessionStorage.removeItem("calibrationErrorStage");
    sessionStorage.removeItem("calibrationErrorReference");
    setMessage("");
    setStage("");
    setRequestId(null);
  };

  const stageHint = () => {
    switch (stage) {
      case "connector":
        return "Issue occurred while communicating with the Connector App.";
      case "server":
        return "Issue occurred while saving calibration to the server.";
      case "save":
        return "Issue occurred while saving the calibration scan record.";
      default:
        return "The calibration did not complete successfully.";
    }
  };

  return (
    <CardA
      title='Calibration Failed'
      subtitle='Please review the error details below and try again.'
    >
      <div className='row'>
        {message && (
          <div className='col-12 mb-3'>
            <div
              className='alert alert-danger alert-dismissible fade show'
              role='alert'
            >
              <div className='d-flex align-items-center'>
                <i className='bi bi-exclamation-octagon-fill me-2'></i>
                <div>
                  <strong>{stageHint()}</strong> {message}
                  <ErrorReference error={{ requestId }} />
                </div>
              </div>
              <button
                type='button'
                className='btn-close'
                aria-label='Close'
                onClick={clearError}
              ></button>
              <div className='mt-2'>
                <button
                  type='button'
                  className='btn btn-sm btn-outline-dark'
                  onClick={() => setShowTroubleshoot((p) => !p)}
                  aria-expanded={showTroubleshoot}
                >
                  {showTroubleshoot
                    ? "Hide Troubleshooting"
                    : "Show Troubleshooting"}
                </button>
              </div>
              {showTroubleshoot && (
                <div className='mt-3 small'>
                  <ul className='mb-0'>
                    {stage === "connector" && (
                      <>
                        <li>
                          Confirm the Connector App is running and up to date.
                        </li>
                        <li>
                          Verify the device is firmly connected and powered.
                        </li>
                        <li>
                          Ensure the laser is armed and ready for calibration.
                        </li>
                        <li>
                          Verify the calibration chip is properly inserted in
                          the reader.
                        </li>
                      </>
                    )}
                    {(stage === "server" || stage === "save") && ( //tips for server or save stage
                      <>
                        <li>Check network connectivity (VPN / firewall).</li>
                        <li>
                          Retry in a few seconds; transient errors may clear.
                        </li>
                        <li>
                          If persistent, capture logs and contact support.
                        </li>
                      </>
                    )}
                    {stage === "unknown" && (
                      <>
                        <li>Re-seat the calibration chip and retry.</li>
                        <li>Check device connections and indicators.</li>
                      </>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className='row mt-2'>
        <div className='col-12 d-flex justify-content-center gap-3'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => changeStep("return")}
          >
            Back to Device
          </button>
          <button
            type='button'
            className='btn btn-warning'
            onClick={() => changeStep("rescan")}
          >
            Redo Calibration
          </button>
        </div>
      </div>
    </CardA>
  );
};

export default WizardCalibrateFail;
